import React, { useEffect, useRef } from 'react'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'

export default props => {
    const {
        offices,
        selectOffice,
        showZone = true,
        listboxId,
        listboxLabel,
        selectedOfficeId,
        closeListbox
    } = props
    const optionRefs = useRef([])
    const officeList = offices || []
    const selectedIndex = officeList.findIndex(office => String(office.idZone || office.id) === String(selectedOfficeId))
    const initialIndex = selectedIndex >= 0 ? selectedIndex : 0

    useEffect(() => {
        const option = optionRefs.current[initialIndex]
        if (option) option.focus()
    }, [initialIndex])

    const handleSelectOffice = office => {
        selectOffice(office)
    }

    const isMobile = true

    const focusOption = index => {
        const boundedIndex = Math.max(0, Math.min(index, officeList.length - 1))
        const option = optionRefs.current[boundedIndex]
        if (option) option.focus()
    }

    const handleOptionKeyDown = (event, office, index) => {
        if (event.key === 'ArrowDown') {
            event.preventDefault()
            focusOption(index + 1)
        } else if (event.key === 'ArrowUp') {
            event.preventDefault()
            focusOption(index - 1)
        } else if (event.key === 'Home') {
            event.preventDefault()
            focusOption(0)
        } else if (event.key === 'End') {
            event.preventDefault()
            focusOption(officeList.length - 1)
        } else if (event.key === 'Enter' || event.key === ' ') {
            event.preventDefault()
            handleSelectOffice(office)
        } else if (event.key === 'Escape') {
            event.preventDefault()
            closeListbox()
        }
    }

    return (
        <div className='list-offices' id={listboxId} role='listbox' aria-label={listboxLabel}>
            {officeList.map((office, i) => {
                const isSelected = i === selectedIndex
                return <div
                    className='office-item'
                    role='option'
                    aria-selected={isSelected}
                    tabIndex={i === initialIndex ? 0 : -1}
                    ref={option => { optionRefs.current[i] = option }}
                    onClick={() => handleSelectOffice(office)}
                    onKeyDown={event => handleOptionKeyDown(event, office, i)}
                    key={office.idZone || office.id || i}
                >
                    <div className='office-icon'>
                        {office.type === 'Aeropuerto' && <FontAwesomeIcon icon="plane-departure" aria-hidden="true" />}
                        {office.type === 'Hotel' && <FontAwesomeIcon icon="hotel" aria-hidden="true" />}
                        {office.type === 'Muelle' && <FontAwesomeIcon icon="anchor" aria-hidden="true" />}
                        {office.type === 'Oficina' && <FontAwesomeIcon icon="building" aria-hidden="true" />}
                    </div>

                    {isMobile ? (
                        <div className='office-name-block'>
                            <div className='office-name'>{office.name}</div>
                            {showZone && <div className='office-city'>{office.city}</div>}
                        </div>
                    ) : (
                        <>
                            <div className='office-name'>{office.name}</div>
                            {showZone && <div className='office-zone'>{office.city}</div>}
                        </>
                    )}
                </div>
            })}
        </div>
    )
}

